














































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import TreeSelect from "@riophae/vue-treeselect";
import organization from "../../../store/entities/basedata/organizationpo";
@Component({
  components: { TreeSelect },
})
export default class EditOrganizationItem extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  organization: organization = new organization();
  loading: boolean = false;
  created() {
    this.itemDetail();
    this.itemtree();
  }
  save() {
    (this.$refs.orgForm as any).validate(async (valid: boolean) => {
      if (valid) {
        if (this.organization.id === this.organization.parentId) {
          this.$Modal.warning({
            title: this.L("ErrorInfo"),
            content: "上级节点不允许为当前节点",
          });
          return;
        }
        this.loading = true;
        await this.$store
          .dispatch({
            type: "organization/update",
            data: this.organization,
          })
          .catch((err) => {
            this.loading = false;
          });
        this.loading = false;
        (this.$refs.orgForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.orgForm as any).resetFields();
    this.$emit("input", false);
  }
  async itemDetail() {
    await this.$store
      .dispatch({
        type: "itemdetail/getdetaillist",
        data: 1,
      })
      .then((val) => {
        this.$data.itemdetail = val;
        //console.log(this.$data.itemdetail)
      })
      .catch((err) => {
        console.log(err);
      });
  }
  async itemtree() {
    await this.$store
      .dispatch("organization/getselectTree")
      .then((val) => {
        this.$data.optionsMechanism = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.organization = Util.extend(
        true,
        {},
        this.$store.state.organization.editOrganization
      );
      if (this.organization.itemDetailId) {
        this.organization.itemDetailId =
          this.organization.itemDetailId.toString();
      }
    }
  }
  itemRule = {
    displayName: [
      {
        required: true,
        message: this.L("NameCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    code: [
      {
        required: true,
        message: this.L("Encode") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    itemDetailId: [
      {
        required: true,
        message: this.L("Category") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  data() {
    return {
      optionsMechanism: [],
      itemdetail: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
